<template>
    <div>
        <div class="smart-main-search-container flex flex-wrap">
            <div class="w-180 mr-10">
                <el-input v-model="searchParams.userName" placeholder="请输入用户名"></el-input>
            </div>
            <div class="w-180 mr-10">
                <el-input v-model="searchParams.userNo" placeholder="请输入用户编号"></el-input>
            </div>
            <div class="w-180 mr-10">
                <el-input v-model="searchParams.tel" placeholder="请输入用户电话"></el-input>
            </div>
            <div class="w-180 mr-10">
                <el-input v-model="searchParams.idcard" placeholder="请输入用户身份证"></el-input>
            </div>
            <div class="w-180 mr-10">
                <el-input v-model="searchParams.meterNo" placeholder="请输入电表号"></el-input>
            </div>
            <div class="w-180 mr-10">
                <el-input v-model="searchParams.conNo" placeholder="请输入集中器号"></el-input>
            </div>

            <div class="w-180 mr-10">
                <el-input v-model="searchParams.userAddr" placeholder="请输入地址"></el-input>
            </div>


            <div class="w-180 mr-10">
                <date-picker v-model="searchParams.startDateStr" value-format="yyyy-MM-dd"
                             placeholder="请选择开始时间"></date-picker>
            </div>
            <div class="w-180 mr-10">
                <date-picker v-model="searchParams.endDateStr" value-format="yyyy-MM-dd"
                             placeholder="请选择结束时间"></date-picker>
            </div>
            <div class="w-180 mr-10">
                <date-picker v-model="searchParams.startDateStr2" value-format="yyyy-MM-dd"
                             placeholder="请选择未交费开始时间"></date-picker>
            </div>
            <div class="w-180 mr-10">
                <date-picker v-model="searchParams.endDateStr2" value-format="yyyy-MM-dd"
                             placeholder="请选择未交费结束时间"></date-picker>
            </div>
            <div class="w-180 mr-10">
                <dropdown placeholder="请选择缴费状态" v-model="searchParams.feeState"
                          :data-list="globalData.feestateList"></dropdown>
            </div>
            <!--<div class="w-180 mr-10">-->
            <!--<dropdown  placeholder="请选择运行状态" v-model="searchParams.status" :data-list="globalData.runstateList" ></dropdown>-->
            <!--</div>-->
            <div class="w-180 mr-10">
                <dropdown placeholder="请选择继电器状态" v-model="searchParams.relayState"
                          :data-list="globalData.relaystateList"></dropdown>
            </div>
            <div class="flex-1"></div>
            <div class="flex">
                <load-button @on-click="search"></load-button>
            </div>
            <div class="flex">
                <el-button type="primary" @click="add" plain>新增用户</el-button>
                <el-button type="primary" @click="exportE" plain>导出数据</el-button>
                <upload-button type="primary"  file-char="file" url="/smartMeter/export/user" plain>导入人员</upload-button>
                <el-button type="primary" @click="exportTemp" plain>下载模板</el-button>
            </div>
            <div class="flex">
                <el-button type="primary" @click="send" plain>发送消息</el-button>
            </div>


        </div>
        <el-button type="text">集中器在线数量：{{meterReading.onLineCount}}</el-button>
        <el-button type="text">集中器不在线数量：{{meterReading.offLineCount}}</el-button>
        <el-button type="text">上次抄表时间：{{meterReading.readTime}}</el-button>
        <el-button type="text">抄表成功数量：{{meterReading.successCount}}</el-button>
        <el-button type="text">抄表失败数量：{{meterReading.errorCount}}</el-button>

        <div class="content mt-20">
            <smart-table :table-label="labels" :table-data="searchData.list" :table-opt="opt"></smart-table>
        </div>

        <div class="flex flex-right mt-20">

            <pagination :page="searchParams.page" :pages="searchData" @on-search="toPage"></pagination>
        </div>
        <form-dialog ref="model" title="用户信息" @on-confirm="save">
            <div slot="dialog-main">
                <el-form v-if="page == 1">
                    <div class="flex flex-mid">
                        <div class="flex-1">
                            <el-form-item label="用户账号" label-width="120px">
                                <el-input :disabled="temp.id!=undefined" v-model="temp.passport"></el-input>
                            </el-form-item>
                        </div>
                        <div class="flex-1">
                            <el-form-item label="密码" label-width="120px">
                                <el-input v-model="temp.password"></el-input>
                            </el-form-item>
                        </div>
                    </div>

                    <div class="flex flex-mid">
                        <div class="flex-1">
                            <el-form-item label="用户编号" label-width="120px">
                                <el-input v-model="temp.userNo"></el-input>
                            </el-form-item>
                        </div>
                        <div class="flex-1">
                            <el-form-item label="表号" label-width="120px">
                                <el-input v-model="temp.meterNo"></el-input>
                            </el-form-item>
                        </div>
                    </div>


                    <div class="flex flex-mid">
                        <div class="flex-1">
                            <el-form-item label="报警金额" label-width="120px">
                                <el-input v-model="temp.alarmAmount"></el-input>
                            </el-form-item>
                        </div>
                        <div class="flex-1">
                            <el-form-item label="拉闸门限" label-width="120px">
                                <el-input v-model="temp.tripAmount"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="flex flex-mid">
                        <div class="flex-1">
                            <el-form-item label="电表密码" label-width="120px">
                                <el-input v-model="temp.meterPassword"></el-input>
                            </el-form-item>
                        </div>
                        <div class="flex-1">
                            <el-form-item label="姓名" label-width="120px">
                                <el-input v-model="temp.userName"></el-input>
                            </el-form-item>
                        </div>
                    </div>

                    <div class="flex flex-mid">
                        <div class="flex-1">
                            <el-form-item label="身份证" label-width="120px">
                                <el-input v-model="temp.idCard"></el-input>
                            </el-form-item>
                        </div>
                        <div class="flex-1">
                            <el-form-item label="电话" label-width="120px">
                                <el-input v-model="temp.tel"></el-input>
                            </el-form-item>
                        </div>
                    </div>




                    <div class="flex flex-mid">
                        <div class="flex-1">
                            <el-form-item label="电价" label-width="120px">
                                <dropdown v-model="temp.priceId" data-url="/smartMeter/price/all" value-key="id"
                                          show-key="name"></dropdown>
                            </el-form-item>
                        </div>
                        <div class="flex-1">
                            <el-form-item label="集中器" label-width="120px">
                                <dropdown placeholder="请选择集中器" v-model="temp.concentratorId"
                                          data-url="/smartMeter/concentrator/all" value-key="id"
                                          show-key="dtuNo"></dropdown>
                            </el-form-item>
                        </div>
                    </div>
                    <div  v-if="temp.id==undefined" class="flex flex-mid">
                        <div class="flex-1">
                            <el-form-item label="开户金额/余额" label-width="120px">
                                <el-input :disabled="temp.id!=undefined"  v-model="temp.realAmount"></el-input>
                            </el-form-item>
                        </div>
                        <div class="flex-1">
                            <el-form-item label="开户电量" label-width="120px">
                                <el-input :disabled="temp.id!=undefined"  v-model="temp.initTotalNum"></el-input>
                            </el-form-item>
                        </div>
                    </div>

                    <div v-if="temp.id==undefined" class="flex flex-mid">

                            <el-form-item label="尖" label-width="20px">
                                <el-input :disabled="temp.id!=undefined" v-model="temp.initSharpNum"></el-input>
                            </el-form-item>

                            <el-form-item label="峰" label-width="20px">
                                <el-input :disabled="temp.id!=undefined" v-model="temp.initPeakNum"></el-input>
                            </el-form-item>

                            <el-form-item label="平" label-width="20px">
                                <el-input :disabled="temp.id!=undefined" v-model="temp.initFlatNumm"></el-input>
                            </el-form-item>

                            <el-form-item label="谷" label-width="20px">
                                <el-input :disabled="temp.id!=undefined" v-model="temp.initValleyNum"></el-input>
                            </el-form-item>

                    </div>

                    <div class="flex flex-mid">
                        <div class="flex-1">
                            <el-form-item label="地址" label-width="120px">
                                <el-input v-model="temp.userAddr"></el-input>
                            </el-form-item>
                        </div>

                    </div>
                </el-form>
                <el-form v-if="page == 2">

                    <div class="flex flex-mid">
                        <div class="flex-1">
                            <el-form-item label="充值金额" label-width="120px">
                                <el-input v-model="temp.payAmount"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>
                <el-form v-if="page == 3">
                    <chat :user="temp"></chat>
                </el-form>
                <el-form v-if="page == 4">
                    <div class="flex flex-mid">
                        <div class="flex-1">
                            <el-form-item label="消息内容" label-width="120px">
                                <el-input type="textarea" v-model="content"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>
            </div>
        </form-dialog>
    </div>
</template>
<script>
    import LoadButton from "../../components/LoadButton";
    import Pagination from "../../components/Pagination";
    import SmartTable from "../../components/SmartTable";
    import FormDialog from "../../components/FormDialog";
    import UploadImg from "../../components/UploadImg";
    import Dropdown from "../../components/Dropdown";
    import DatePicker from "../../components/DatePicker";
    import Chat from "../../components/Chat";
    import UploadButton from "../../components/UploadButton";

    export default {
        components: {
            Chat,
            DatePicker,
            Dropdown,
            UploadImg,
            FormDialog,
            SmartTable,
            Pagination,
            LoadButton,
            UploadButton,

        },
        data() {
            return {
                meterReading:{

                },
                searchParams: {
                    page: 1
                },
                searchData: {},
                opt: [
                    {label: '编辑', fn: this.getDetail},
                    {label: '拉闸', fn: this.switchOut},
                    {label: '合闸', fn: this.switchIn},
                    {label: '抄表', fn: this.readerMeter},
                    {label: '充值', fn: this.recharge},
                    {label: '消息', fn: this.notice},
                    {label: '删除', fn: this.del},
                ],
                labels: [
                    {prop: 'userName', label: '用户名'},
                    {prop: 'userNo', label: '编号'},
                    {prop: 'priceName', label: '电价类型'},
                    {prop: 'totalNum', label: '总用电'},
                    {prop: 'totalConsume', label: '总电费'},
                    {prop: 'totalEndNum', label: '总电量'},


                    {prop: 'idCard', label: '身份证'},
                    {prop: 'tel', label: '电话'},


                    {prop: 'realAmount', label: '当前余额'},
                    {prop: 'relayState', label: '拉闸状态', map: this.globalData.relaystateList},
                    {prop: 'conNo', label: '集中器号'},
                    {prop: 'conStatus', label: '运行状态',map: this.globalData.conRunStatus},
                    {prop: 'feeState', label: '缴费状态', map: this.globalData.feestateList},
                    {prop: 'userAddr', label: '地址'},
                    // {prop: 'unreadCount', label: '新消息'},
                ],
                temp: {},
                page: 1,
                content: ''
            }
        },
        computed: {
            list() {
                let arr = []
                for (var i in this.$store.state.tasKeyMap) {
                    arr.push({id: i, name: this.$store.state.tasKeyMap[i]})
                }
                return arr
            },
        },
        mounted() {
            this.getList()
        },
        methods: {
            search(stop) {
                this.searchParams.page = 1
                this.getList(stop)
            },
            toPage(page) {
                this.searchParams.page = page
                this.getList()
            },
            getList(callback) {

                this.$http$({method: 'get', url: "/smartMeter/accountTab/meterReader"}, (data) => {
                    callback ? callback() : ''
                    this.meterReading = data
                })
                this.$http$({method: 'get', url: "/smartMeter/user", data: this.searchParams, load: 1}, (data) => {
                    callback ? callback() : ''
                    this.searchData = data
                })
            },
            getDetail(obj) {
                this.temp = JSON.parse(JSON.stringify(obj))
                if (this.$store.state.LoginUser.gardenId) {
                    this.temp.gardenid = this.$store.state.LoginUser.gardenId
                }
                this.$refs.model.show()
            },
            switchOut(obj) {
                this.$http$({method: 'post', url: "/smartMeter/user/meterOff", data: obj}, (data) => {
                    this.$success('拉闸成功！')
                })
            },
            switchIn(obj) {
                this.$http$({method: 'post', url: "/smartMeter/user/meterOn", data: obj}, (data) => {
                    this.$success('合闸成功！')
                })
            },
            // monitor(obj){
            //   this.$http$({method: 'post', url: "/smartMeterServer/ExeTaskList/add/4", data: obj}, (data) => {
            //     this.$success('监控成功！')
            //   })
            // },
            recharge(obj) {
                this.page = 2
                this.temp = JSON.parse(JSON.stringify(obj))
                this.$refs.model.show()
            },

            saveRecharge(obj) {
                this.temp.payType = 1
                this.temp.operName = this.$store.state.LoginUser.name
                this.temp.userId = this.temp.id;

                this.$http$({method: 'post', url: "/smartMeter/paymentLog/add", data: this.temp}, (data) => {
                    this.$success('充值成功！')
                    this.getList()
                })
            },
            notice(obj) {
                this.temp = obj
                this.page = 3
                this.$refs.model.show()
            },
            add() {
                this.page = 1
                if(this.temp){
                    this.temp.id = undefined;
                }else{
                    this.temp = {}
                }


                if (this.$store.state.LoginUser.gardenId) {
                    this.temp.gardenid = this.$store.state.LoginUser.gardenId
                }
                this.$refs.model.show()
            },
            send() {

                this.page = 4
                this.content = ''
                this.$refs.model.show()
            },
            save() {

                if (this.page == 1) {
                    let method = 'post', url = '/smartMeter/user', msg = '新增用户成功！'
                    if (this.temp.id) {
                        method = "put"
                        msg = "修改成功"
                        // url = '/smartMeter/user'
                        msg = '修改用户成功！'
                    }
                    this.$http$({method: method, url: url, data: this.temp}, (data) => {
                        this.getList()
                        this.$success(msg)
                    })
                } else if (this.page == 2) {
                    this.saveRecharge()
                } else if (this.page == 4) {
                    let isUser =  this.$store.state.LoginUser.type == 3;
                    let adminRead = isUser? 0 : 1
                    let userRead = isUser ? 1 : 0
                    const params = {
                        content: this.content,
                        name: this.$store.state.LoginUser.name,
                        adminRead: adminRead,
                        userRead: userRead,
                        type: this.$store.state.LoginUser.type,
                        gardenId: this.$store.state.LoginUser.gardenId
                    }
                    this.$http$({method: 'post', url: '/smartMeter/message/addAll', data: params}, (data) => {
                        this.getList()
                        this.$success('发送成功！')
                    })
                }


            },
            exportE(){
                let url =  this.globalData.host+ "/smartMeter/export/user?accessToken="+this.$store.state.LoginUser.accessToken||"";
                // var isFirst = true;
                for (var i in this.searchParams){
                    url += "&";
                    url+= encodeURIComponent(i) +"=" +encodeURIComponent(this.searchParams[i]);
                }
                this.$http$({method: 'get', url: url}, () => {
                    this.$router.push('/admin/downLoadTask')
                })
            },
            exportTemp(){
                let url =  this.globalData.host+ "/smartMeter/export/user/temp?accessToken="+this.$store.state.LoginUser.accessToken||"";
                // var isFirst = true;
                for (var i in this.searchParams){
                    url += "&";
                    url+= encodeURIComponent(i) +"=" +encodeURIComponent(this.searchParams[i]);
                }
                window.open(url);

                // this.$http$({method: 'get', url: url}, () => {
                //     this.$router.push('/admin/downLoadTask')
                //
                // })
            },

            del(obj){
                this.$fnConfirm('确认删除？',() => {
                    this.$http$({method: 'delete', url: "/smartMeter/user/"+obj.id}, (data) => {
                        // callback ? callback() : ''
                        // this.searchData = data
                        this.getList();
                    })
                });


            },
            readerMeter(obj){
                this.$http$({method: 'get', url: "/smartMeter/user/meterReader/"+obj.id}, (data) => {
                    this.$success("发送抄表指令成功！")
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/admin/Users.vue